<template>
    <div class="video-item" v-if="data.image">
        <div class="video-content">
            <!-- <img :src="data.image" @click="goto()" /> -->
            <img v-lazy="data.image" alt="" @click="goto()">
            <div class="video-title" @click="goto()">
                <span v-if="data.index">{{data.index}}</span>
                <span v-else>{{data.title}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['data'],
  methods: {
    goto () {
      const dest = (this.data.route ? this.data.route : '/p/' + this.data.id)
      console.log('goto: ', dest)
      this.$router.push({path: dest})
    }
  }
}
</script>

<style>
.video-item {
    margin: 5px auto;
}
.video-content {
    margin-bottom: 24px;
}
.video-content img {
    width: 290px;
    height: 160px;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/VideoItem.vue